export default class WeeklyResults {
    constructor() {
        this.table = document.querySelector('.weekly-results-table');
        this.underdogToggle = document.getElementById('show-underdogs');
        
        if (this.table && this.underdogToggle) {
            this.init();
        }
    }

    init() {
        this.setupUnderdogToggle();
    }

    setupUnderdogToggle() {
        this.underdogToggle.addEventListener('change', (e) => {
            const isChecked = e.target.checked;
            
            if (isChecked) {
                // Keep your original class naming convention
                this.table.classList.add('show-underdog-picks');
            } else {
                this.table.classList.remove('show-underdog-picks');
            }
        });
    }
}